export default "__VITE_ASSET__OOzBZg3i__"